import { render, staticRenderFns } from "./file-table-dialog.vue?vue&type=template&id=2589962d&scoped=true"
import script from "./file-table-dialog.vue?vue&type=script&lang=js"
export * from "./file-table-dialog.vue?vue&type=script&lang=js"
import style0 from "./file-table-dialog.vue?vue&type=style&index=0&id=2589962d&prod&lang=less&scoped=true"
import style1 from "./file-table-dialog.vue?vue&type=style&index=1&id=2589962d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2589962d",
  null
  
)

export default component.exports